/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getTimesheetCustomersQueryParamsSchema = z
  .object({
    search: z.string().optional(),
    mockUser: z.coerce.number().int().optional(),
  })
  .optional();

/**
 * @description OK
 */
export const getTimesheetCustomers200Schema = z.array(
  z.object({
    customerId: z.coerce.number().int(),
    customerName: z.coerce.string(),
  }),
);

export const getTimesheetCustomersQueryResponseSchema = z.lazy(
  () => getTimesheetCustomers200Schema,
);
